import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { blogRoute } from '.'

const Blogs = lazyRouteComponent(() => import('../../pages/blogs/blogs'))

export const blogsListRoute = createRoute({
  getParentRoute: () => blogRoute,
  path: '/',
  component: Blogs,
})
